import React from 'react'
import Link from 'next/link'
import { Home, Lock, LogIn } from 'lucide-react'
import { Button } from '~/components/ui/button'

const Page401 = () => {
    return (
        <div className='bg-background flex min-h-screen flex-col items-center justify-center px-4 py-16'>
            <div className='mx-auto max-w-md text-center'>
                <h1 className='text-foreground mb-4 text-6xl font-bold sm:text-7xl'>401</h1>

                <h2 className='text-foreground mb-3 text-2xl font-semibold sm:text-3xl'>Không được phép truy cập</h2>

                <p className='text-muted-foreground mb-8'>
                    Bạn cần đăng nhập để truy cập trang này. Vui lòng đăng nhập bằng tài khoản của bạn để tiếp tục.
                </p>

                <div className='flex flex-col gap-3 sm:flex-row sm:justify-center'>
                    <Button asChild size='lg' className='w-full'>
                        <Link href='/login'>
                            <LogIn className='h-4 w-4' />
                            Đăng nhập
                        </Link>
                    </Button>
                    <Button asChild variant='outline' size='lg' className='w-full'>
                        <Link href='/'>
                            <Home className='h-4 w-4' />
                            Về trang chủ
                        </Link>
                    </Button>
                </div>

                <div className='border-border bg-muted/50 mt-8 rounded-lg border p-4 text-left'>
                    <p className='text-muted-foreground mt-2 text-sm'>
                        Trang này yêu cầu xác thực. Nếu bạn đã có tài khoản, vui lòng đăng nhập. Nếu chưa có tài khoản,
                        bạn có thể đăng ký để truy cập.
                    </p>
                </div>
            </div>
        </div>
    )
}

export default Page401

